<template>
  <div class="layout-content">
    <main class="main-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'AppLayout'
};
</script>

<style lang="scss" scoped>
/* Layout styles */
.layout-content {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

.main-content {
  flex: 1;
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
